var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('b-list-group-item', {
    directives: [{
      name: "b-modal",
      rawName: "v-b-modal.modal-add-customer",
      modifiers: {
        "modal-add-customer": true
      }
    }],
    staticClass: "d-flex align-items-center border-0"
  }, [_c('b-button', {
    staticClass: "flex-shrink-0 mb-2 mb-xl-0",
    attrs: {
      "variant": "primary"
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  }), _vm._v("選擇會員 ")]), _c('b-modal', {
    attrs: {
      "id": "modal-add-customer",
      "title": "選擇會員",
      "body-class": "modal-height",
      "centered": ""
    },
    on: {
      "show": _vm.refreshSearch
    },
    scopedSlots: _vm._u([{
      key: "modal-footer",
      fn: function fn() {
        return [_c('div', {
          staticClass: "w-100"
        }, [_c('div', {
          staticClass: "float-right"
        }, [_c('svg', {
          staticClass: "mr-2 arrow-point",
          attrs: {
            "width": "40",
            "height": "40",
            "viewBox": "0 0 40 40",
            "fill": "none",
            "xmlns": "http://www.w3.org/2000/svg"
          },
          on: {
            "click": function click($event) {
              return _vm.changePage(-1);
            }
          }
        }, [_c('path', {
          attrs: {
            "d": "M17.1816 20.3398C17.1816 20.5352 17.2598 20.7109 17.4062 20.8574L24.7598 27.9375C24.8965 28.0742 25.0723 28.1523 25.2773 28.1523C25.6777 28.1523 25.9902 27.8398 25.9902 27.4297C25.9902 27.2246 25.9121 27.0586 25.7852 26.9219L18.9395 20.3398L25.7852 13.748C25.9121 13.6113 25.9902 13.4355 25.9902 13.2402C25.9902 12.8301 25.6777 12.5273 25.2773 12.5273C25.0723 12.5273 24.8965 12.5957 24.7598 12.7324L17.4062 19.8125C17.2598 19.959 17.1816 20.1348 17.1816 20.3398Z",
            "fill": "black"
          }
        })]), _c('svg', {
          staticClass: "mr-5 arrow-point",
          attrs: {
            "width": "40",
            "height": "40",
            "viewBox": "0 0 40 40",
            "fill": "none",
            "xmlns": "http://www.w3.org/2000/svg"
          },
          on: {
            "click": function click($event) {
              return _vm.changePage(1);
            }
          }
        }, [_c('path', {
          attrs: {
            "d": "M25.3438 20.3398C25.3438 20.1348 25.2656 19.959 25.1191 19.8125L17.7656 12.7324C17.6289 12.5957 17.4531 12.5273 17.248 12.5273C16.8477 12.5273 16.5352 12.8301 16.5352 13.2402C16.5352 13.4355 16.6133 13.6113 16.7402 13.748L23.5859 20.3398L16.7402 26.9219C16.6133 27.0586 16.5352 27.2246 16.5352 27.4297C16.5352 27.8398 16.8477 28.1523 17.248 28.1523C17.4531 28.1523 17.6289 28.0742 17.7656 27.9375L25.1191 20.8574C25.2656 20.7109 25.3438 20.5352 25.3438 20.3398Z",
            "fill": "black"
          }
        })]), _c('b-button', {
          staticClass: "mr-2 ml-5",
          attrs: {
            "variant": "danger",
            "size": "sm"
          },
          on: {
            "click": _vm.closeModal
          }
        }, [_vm._v(" 取消 ")]), _c('b-button', {
          attrs: {
            "variant": "primary",
            "size": "sm"
          },
          on: {
            "click": _vm.submitAddMember
          }
        }, [_vm._v(" 確定 ")])], 1)])];
      },
      proxy: true
    }]),
    model: {
      value: _vm.show,
      callback: function callback($$v) {
        _vm.show = $$v;
      },
      expression: "show"
    }
  }, [_c('b-input-group', [_c('b-form-input', {
    attrs: {
      "placeholder": "請輸入姓名或Line Uid"
    },
    on: {
      "keyup": function keyup($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.fetchCustomers.apply(null, arguments);
      }
    },
    model: {
      value: _vm.customerKeyword,
      callback: function callback($$v) {
        _vm.customerKeyword = $$v;
      },
      expression: "customerKeyword"
    }
  }), _c('b-input-group-append', [_c('b-button', {
    on: {
      "click": _vm.fetchCustomers
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  })])], 1)], 1), _vm.loading ? _c('div', {
    staticClass: "text-center mt-3 mb-3 loading-spinner"
  }, [_c('b-spinner', {
    attrs: {
      "variant": "secondary",
      "small": ""
    }
  })], 1) : _vm._e(), _vm.customers.length > 0 && !_vm.loading ? _c('div', {
    staticClass: "scrolling"
  }, _vm._l(_vm.customers, function (customer, index) {
    return _c('div', {
      key: index
    }, [_c('div', {
      staticClass: "d-flex align-items-center py-2 staff-info",
      on: {
        "click": function click($event) {
          return _vm.handleSelected(customer);
        }
      }
    }, [_c('b-avatar', {
      staticClass: "mx-2",
      attrs: {
        "src": customer.avatar_url
      }
    }), _c('div', {
      staticClass: "\n              mr-auto\n              font-weight-bold\n              text-nowrap text-truncate\n            "
    }, [_vm._v(" " + _vm._s(customer.name) + " "), _c('span', {
      staticClass: "staff-list-info"
    }, [_vm._v(" " + _vm._s(customer.email)), _c('br'), _vm._v(" " + _vm._s(_vm.displayCustomerInfo(customer)) + " ")])])], 1)]);
  }), 0) : _vm._e(), _vm.selectedCustomer ? _c('div', {
    staticClass: "d-flex align-items-center py-3"
  }, [_c('b-avatar', {
    staticClass: "mr-2",
    attrs: {
      "src": _vm.selectedCustomer.avatar_url
    }
  }), _c('div', {
    staticClass: "\n          mr-auto\n          font-weight-bold\n          text-nowrap text-truncate\n          flex-fill\n        "
  }, [_vm._v(" " + _vm._s(_vm.selectedCustomer.name) + " "), _c('span', {
    staticClass: "staff-list-info"
  }, [_vm._v(" " + _vm._s(_vm.selectedCustomer.email)), _c('br'), _vm._v(" " + _vm._s(_vm.displayCustomerInfo(_vm.selectedCustomer)) + " ")])]), _c('b-button', {
    staticClass: "p-1 mr-2",
    attrs: {
      "size": "xs",
      "pill": "",
      "variant": "danger"
    },
    on: {
      "click": _vm.cancelSelected
    }
  }, [_c('i', {
    staticClass: "fa fa-times m-0"
  })])], 1) : _vm._e()], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }